export class Constants {
    public static AuthtokenKey: string = "authToken";
    public static AuthenticationResult: string = "authenticationResult";
}